// Original hypothetical scenarios; historical risk estimates are not guarantees.
export const riskReview = {
  moduleId: 'risk',
  title: '風險指標，能回答什麼、不能保證什麼',
  questions: [
    {
      id: 'risk-negative-sharpe-ranking',
      lessonId: 'sharpe-ratio',
      question: '兩個假想方案以相同期間的年報酬計算，算術平均都為 1.2%，每年的無風險報酬固定 2.4%。A 的年報酬標準差為 6%，B 為 12%。依「平均超額報酬 ÷ 超額報酬標準差」計算，哪個解讀正確？',
      options: [
        'B 的 Sharpe 較高，所以只靠這個數字就能證明 B 較值得持有',
        '兩個方案平均報酬都是正值，因此 Sharpe 也一定為正',
        'A 為 −0.20、B 為 −0.10；B 數字較高來自較大的分母，不能直接當成較好的證明',
      ],
      answer: 2,
      explanation: '兩者平均超額報酬均為 1.2%−2.4%＝−1.2%。無風險報酬固定，扣掉它不改變標準差，所以 A＝−1.2 ÷ 6＝−0.20，B＝−1.2 ÷ 12＝−0.10。負分子下，波動較大反而讓比值更接近 0；不能機械式地按大小排名。比較時還須對齊期間、頻率與基準，標準差為 0 時也不能照常相除。',
    },
    {
      id: 'risk-zero-correlation-not-zero-risk',
      lessonId: 'correlation-risk',
      question: '同一觀察期間、同幣別的假想年報酬估計中，A、B 標準差分別為 12%、16%，相關係數為 0。用各 50% 的固定權重形成兩資產組合，依兩資產變異數公式，哪個敘述正確？',
      options: [
        '相關係數是 0，所以組合標準差也是 0，不可能虧損',
        '組合標準差為 10%，仍有風險；相關係數 0 不等於兩資產不會同時下跌',
        '組合標準差必定為 14%，直接平均兩個標準差就好',
      ],
      answer: 1,
      explanation: '相關係數為 0 時，共變動項為 0，組合標準差＝√［0.5²×0.12²＋0.5²×0.16²］＝0.10，也就是 10%。這低於 14% 的加權平均，但並非無風險。相關係數描述線性關係，0 也不代表完全沒有關聯；這段樣本的估計不保證未來相關性或波動相同。',
    },
    {
      id: 'risk-var-threshold-not-cap',
      lessonId: 'tail-risk',
      question: '某假想組合的風險報告列出「一天、99% 信賴水準的 VaR 為 18,000 元」。只依這個估計，哪個敘述正確？',
      options: [
        '一天損失仍可能超過 18,000 元；這個數字沒有交代越過門檻後會虧多少',
        '只要沒有改變持股，一天最多只會虧 18,000 元',
        '未來每 100 個交易日，保證剛好只有 1 天虧超過 18,000 元',
      ],
      answer: 0,
      explanation: 'VaR 是指定期間、資料與模型下的損失分位門檻，不是損失上限，也不是未來事件次數的保證。超過門檻後的損失幅度可能很大，而模型假設與估計本身也可能失準。要理解尾端後果，還需要查看尾端損失資訊與壓力情境，不能把 VaR 當成停損保證。',
    },
    {
      id: 'risk-backtest-information-timing',
      lessonId: 'backtest-bias',
      question: '一份假想回測在模擬 1 月 8 日的決策時，使用 2 月 20 日才首次公開的財報；資料集又刪掉後來下市的公司。哪個判斷正確？',
      options: [
        '只要財報內容真實，就能視為 1 月 8 日已經知道',
        '只要回測期間夠長，這兩項資料問題就會自動消失',
        '同時有前視偏誤與存活者偏誤，需要重建當時能取得的資訊與公司名單',
      ],
      answer: 2,
      explanation: '決策時尚未公開的資訊形成前視偏誤；排除之後下市的公司，則會讓樣本只留下部分存活者。應依當時的發布時間取資料，保留當時可投資但之後消失的公司並合理處理其損益，再檢查費用、交易限制與未參與調參的樣本。修正回測仍不能保證未來績效。',
    },
  ],
};
